<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <v-card tile :height="$vuetify.breakpoint.lgAndUp ? '800' : 'auto'" img="/images/common/lawyer/subvisual-lawyer-bg.jpg" style="background-attachment: fixed">
                <v-container class="d-flex h-100">
                    <div class="w-100 mt-80px mt-lg-auto">
                        <v-row no-gutters align-md="end" justify="center" justify-md="space-between">
                            <v-col cols="1" class="d-none d-md-block" />
                            <v-col cols="12" md="auto">
                                <div class="mb-20px mb-md-0">
                                    <v-img :max-width="$vuetify.breakpoint.lgAndUp ? '590' : '280'" :src="`/images/lawyer/${lawyer?.code}.png`" class="mx-auto" />
                                </div>
                            </v-col>
                            <v-col cols="12" md="">
                                <div data-aos="fade-up" data-aos-duration="600" data-aos-anchor-placement="top-bottom" class="mb-40px mb-md-60px mb-lg-80px text-center text-md-right white--text">
                                    <div class="tit-wrap tit-wrap--sm">
                                        <h3 class="font-size-30 font-size-md-60 font-size-lg-72 line-height-11">{{ lawyer?.name }}</h3>
                                        <div class="tit tit--xs font-weight-medium line-height-11 white--text mt-6px mt-md-10px">{{ lawyer?.rank }}</div>
                                    </div>
                                    <div>
                                        <v-row justify="center" justify-md="end" class="row--sm txt white--text">
                                            <v-col cols="auto">
                                                <strong>전화번호</strong>
                                            </v-col>
                                            <v-col cols="auto">
                                                <span>{{ lawyer?.phone }}</span>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div class="pt-4px pt-md-8px">
                                        <v-row justify="center" justify-md="end" class="row--sm txt white--text">
                                            <v-col cols="auto">
                                                <strong>Email</strong>
                                            </v-col>
                                            <v-col cols="auto">
                                                <span>{{ lawyer?.email }}</span>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </v-card>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first pb-0">
            <div class="tit-wrap tit-wrap--sm">
                <h3 class="tit tit--xl tit--point line-height-11">
                    <span>소개</span>
                    <span class="tit--point__circle" data-aos="zoom-in"></span>
                </h3>
            </div>
            <div class="txt line-height-15 overflow-hidden" data-aos="fade" data-aos-duration="600">
                <div v-html="lawyer?.section1?.txt.replace(/\n/gi, '<br/>')"></div>
            </div>
        </page-section>

        <page-section class="page-section--xs page-section--last">
            <v-divider style="border-width: 2px 0 0" class="grey darken-4" />
            <v-expansion-panels flat multiple class="font-secondary">
                <v-expansion-panel>
                    <v-expansion-panel-header class="pa-12px px-md-20px py-md-24px border-b">
                        <div class="tit tit--xxs font-weight-medium">업무 분야</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-5">
                        <div class="px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b">
                            <page-section v-for="(section, index) in lawyer.section2" :key="index" class="page-section--xxs pb-0" :class="{ 'pt-0': index == 0 }">
                                <template #pageSectionImmersive>
                                    <div class="pb-10px pb-md-12px">
                                        <div class="tit tit--xs">{{ section?.title }}</div>
                                    </div>
                                    <div v-for="(columns, index) in section.columns" :key="index" :class="{ 'pt-8px pt-md-10px': index != 0 }">
                                        <v-row class="row--xs txt txt--sm line-height-15">
                                            <v-col>
                                                <v-row class="row--xs">
                                                    <v-col cols="auto">·</v-col>
                                                    <v-col>
                                                        <div>{{ columns?.txt }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </page-section>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- Education -->
                <v-expansion-panel>
                    <v-expansion-panel-header class="pa-12px px-md-20px py-md-24px border-b">
                        <div class="tit tit--xxs font-weight-medium">학력사항</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-5">
                        <div class="px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b">
                            <div v-for="(section, index) in lawyer.section3" :key="index" :class="{ 'pt-8px pt-md-10px': index != 0 }">
                                <v-row class="row--xs txt txt--sm line-height-15">
                                    <v-col cols="12" md="auto">
                                        <div class="txt--dark font-weight-medium min-w-md-90px">{{ section?.title }}</div>
                                    </v-col>
                                    <v-col>
                                        <v-row class="row--xs">
                                            <v-col cols="auto">·</v-col>
                                            <v-col>
                                                <div class="text-pre-wrap">{{ section?.txt }}</div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- Professional Career -->
                <v-expansion-panel>
                    <v-expansion-panel-header class="pa-12px px-md-20px py-md-24px border-b">
                        <div class="tit tit--xxs font-weight-medium">경력사항</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-5">
                        <div class="px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b">
                            <div v-for="(section, index) in lawyer.section4" :key="index" :class="{ 'pt-8px pt-md-10px': index != 0 }">
                                <v-row class="row--xs txt txt--sm line-height-15">
                                    <v-col cols="12" md="auto">
                                        <div class="txt--dark font-weight-medium min-w-md-90px">{{ section?.title }}</div>
                                    </v-col>
                                    <v-col>
                                        <v-row class="row--xs">
                                            <v-col cols="auto">·</v-col>
                                            <v-col>
                                                <div>{{ section?.txt }}</div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- Representative Matters -->
                <v-expansion-panel>
                    <v-expansion-panel-header class="pa-12px px-md-20px py-md-24px border-b">
                        <div class="tit tit--xxs font-weight-medium">주요 업무 수행 사례</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-5">
                        <div class="pa-12px px-md-20px py-md-24px px-lg-60px py-lg-40px">
                            <page-section v-for="(section, index) in lawyer.section5" :key="index" class="page-section--xxs pb-0" :class="{ 'pt-0': index == 0 }">
                                <template #pageSectionImmersive>
                                    <div class="pb-10px pb-md-12px">
                                        <div class="tit tit--xs">{{ section?.title }}</div>
                                    </div>
                                    <div v-for="(column, index) in section.columns" :key="index" :class="{ 'pt-8px pt-md-10px': index != 0 }">
                                        <v-row class="row--xs txt txt--sm line-height-15">
                                            <v-col cols="12" md="auto">
                                                <div class="txt--dark font-weight-medium min-w-md-90px">{{ column?.title }}</div>
                                            </v-col>
                                            <v-col>
                                                <v-row class="row--xs">
                                                    <v-col cols="auto">·</v-col>
                                                    <v-col>
                                                        <div>{{ column?.txt }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </page-section>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <div class="btn-wrap btn-wrap--lg">
                <v-row justify="center">
                    <v-col cols="auto">
                        <v-btn x-large outlined color="grey-darken4" class="min-w-120px min-w-lg-160px" @click="$router.go(-1)">뒤로가기</v-btn>
                    </v-col>
                </v-row>
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
    },
    props: {},
    mounted() {
        this.init();
    },
    data() {
        return {
            lawyer: {},
        };
    },
    methods: {
        async init() {
            let { lawyer } = await api.v1.lawyers.get({ params: { code: this.code, local: "ko" } });
            console.log(lawyer);
            this.lawyer = lawyer;
        },
    },
    computed: {
        code() {
            return this.$route.query.code;
        },
    },
};
</script>
